import { Redirect } from 'react-router-dom';
import ProcessHistoryList from './ProcessHistoryList';
import { usePrismReadLocal } from '../../utils/prismReadLocal';

// 「历史加工数据」列表入口 (2026-10-20): prism 读路径切到本库后, 历史数据已并入「材料加工」,
// 老链接跳到材料加工的历史来源; 切换前照旧显示独立页面. 详情路由 /assets/process-history/:id
// 不跳 —— 老 id 与并表后的新 id 不是简单换算, 老接口在旧表下线前继续可用.
export default function ProcessHistoryEntry() {
    const readLocal = usePrismReadLocal();
    if (readLocal) return <Redirect to="/assets/process-records?origin=history" />;
    return <ProcessHistoryList />;
}
